const appendParam = (params: string, key: string, value: unknown): string => {
    if (value === undefined || value === null || value === '') {
        return params;
    }
    return `${params}${key}=${value}&`;
};

export const buildCommentListPaginationParams = (paginationInfo: any): string => {
    let params = '';
    params += 'pageSize=' + paginationInfo.rowsPerPage + '&';
    params += 'pageNumber=' + paginationInfo.currentPage + '&';
    if (paginationInfo.currentPage) {
        params += 'Page=' + Number(Number(paginationInfo.currentPage) + 1) + '&';
    }
    if (paginationInfo.rowsPerPage) {
        params += 'size=' + paginationInfo.rowsPerPage + '&';
    }
    return params;
};

export const buildCommentListFilterParams = (
    optionId?: string,
    specialCode?: string,
    colorCode?: string,
    createDate?: string,
    endDate?: string,
    starScore?: any,
    commentStatus?: any,
    tagName?: string,
    operator?: string,
    grievanceStatus?: any,
    isAgent?: any
): string => {
    let params = '';
    params = appendParam(params, 'OptionCode', optionId);
    params = appendParam(params, 'SpecialCode', specialCode);
    params = appendParam(params, 'ColorCode', colorCode);
    params = appendParam(params, 'StartDate', createDate);
    params = appendParam(params, 'EndDate', endDate);

    if (starScore && starScore[0]?.id !== -1) {
        params = appendParam(params, 'Point', starScore[0]?.id);
    }

    if (grievanceStatus) {
        params = appendParam(params, 'GrievanceStatus', grievanceStatus[0]?.id);
    } else {
        params = appendParam(params, 'GrievanceStatus', 2);
    }

    if (commentStatus && commentStatus[0]?.id !== -1) {
        params = appendParam(params, 'ApproveStatus', commentStatus[0]?.id);
    }

    if (tagName && tagName.length > 0) {
        for (let i = 0; i < tagName.length; i++) {
            params = appendParam(params, 'ticket', tagName[i]);
        }
    }

    if (isAgent == 1 || isAgent == 0) {
        params = appendParam(params, 'isAgent', isAgent);
    }

    if (operator) {
        params += 'Operator=' + operator + '&';
        if (params[params.length - 3] === '-') {
            params = params.slice(0, -3);
        }
    }

    return params;
};

export const parseCommentListParams = (
    paginationInfo: any,
    optionId?: string,
    specialCode?: string,
    colorCode?: string,
    createDate?: string,
    endDate?: string,
    starScore?: any,
    commentStatus?: any,
    tagName?: string,
    operator?: string,
    grievanceStatus?: any,
    isAgent?: any
): string => {
    return (
        buildCommentListPaginationParams(paginationInfo) +
        buildCommentListFilterParams(
            optionId,
            specialCode,
            colorCode,
            createDate,
            endDate,
            starScore,
            commentStatus,
            tagName,
            operator,
            grievanceStatus,
            isAgent
        )
    );
};
